import React from 'react';

var SvgEyeDropperIcon = function SvgEyeDropperIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.496 8.686 1.16-1.16c.879-.88.879-2.304 0-3.183-.878-.878-2.303-.878-3.182 0l-1.16 1.161-.784-.784c-.293-.293-.768-.293-1.06 0-.294.293-.294.768 0 1.06l.783.785-5.91 5.91c-.88.879-.88 2.303 0 3.182.878.879 2.303.879 3.182 0l5.91-5.91.807.807c.293.293.768.293 1.06 0 .294-.293.294-.768 0-1.061l-.806-.807Zm-2.122 0-5.91 5.91c-.293.293-.768.293-1.06 0-.294-.292-.294-.767 0-1.06l5.91-5.91 1.06 1.06Z"
  }));
};
SvgEyeDropperIcon.displayName = "EyeDropperIcon";

export { SvgEyeDropperIcon as S };
